const host = window.location.hostname;
const isProd = host === 'carbonwallet.zeroemissions.jp';
const isPreProd = host === 'carbonwallet-preprod.zeroemissions.jp';
const APPCONFIG = {
  // endPoint: isProd ? 'https://api.zeroemissions.jp/api' : isPreProd ? 'https://api-preprod.zeroemissions.jp/api' : 'https://api-dev.zeroemissions.jp/api',
  // endPoint: 'https://630b-106-51-0-211.ngrok-free.app/api',
  endPoint: 'https://carbonwallet.zeroemissions.jp/api'
};

export default APPCONFIG;
